import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 400,
      fontSize: '16px',
      gap: '16px',
    },
    icons: {
      display: 'flex',
      gap: '5px',
    },
    icon: {
      width: '46px',
      height: '32px',
    },
    amount: {
      fontWeight: 700,
      fontSize: '16px',
    },
    vendor: {
      fontSize: '12px',
      backgroundColor: 'rgba(238, 238, 238, 1)',
      color: 'rgba(123, 123, 123, 1)',
      padding: '4px',
      borderRadius: '4px',
      whiteSpace: 'nowrap',
    }
  }
))
